import http from "./http";
import { handleHttpError } from "./httpHelpers";

export function getVendorsService(params = {}) {
  const payload = {
    customFunc: {
      name: "cf_ottieniVenditori",
      param: {
        limit: "10",
        page: "1",
        ...params,
      },
    },
  };

  return http
    .post("/api/v1/venditore/customfunc/", payload, { skipAuthRefresh: true })
    .then((res) => res.data)
    .catch((error) => handleHttpError(error));
}

export function getVendorByIdService(vendorId) {
  if (!vendorId) {
    return Promise.resolve(null);
  }

  const payload = {
    customFunc: {
      name: "cf_ottieniVenditore",
      param: {
        venditoreId: vendorId,
      },
    },
  };

  return http
    .post("/api/v1/venditore/customfunc/", payload, { skipAuthRefresh: true })
    .then((res) => res.data?.venditore ?? null)
    .catch((error) => handleHttpError(error));
}

export function getVendorProductsService({ vendorId, limit = "10", page = "1" } = {}) {
  if (!vendorId) {
    return Promise.resolve({ prodotti: [] });
  }

  const payload = {
    customFunc: {
      name: "cf_ottieniProdottiVenditore",
      param: {
        venditoreId: vendorId,
        limit: limit.toString(),
        page: page.toString(),
      },
    },
  };

  return http
    .post("/api/v1/venditore/customfunc/", payload, { skipAuthRefresh: true })
    .then((res) => res.data)
    .catch((error) => handleHttpError(error));
}
